export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
  padding: '2px 0',
  maxHeight: '682px',
};
